import { inject, observer } from 'mobx-react';
import React from 'react';

import { Button, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';

const PrivateArea = ({
    bulletinType,
    privateArea,
    dialogStore: { openLoginDialog },
    userStore: {
        user: { id }
    }
}) => {
    if (!privateArea) {
        return false;
    }

    const unAuthText = (
        <Typography>
            {`This is an article that belongs to ${bulletinType} private collection.`}
            <br /> Please sign in to get more Information.
        </Typography>
    );
    const authText = (
        <Typography>{`This article is a part of ${bulletinType} private collection that available to extended license holders only. Take a look on our price list or contact our customer support team to get more information about available plans.`}</Typography>
    );

    return (
        <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            {id ? authText : unAuthText}
            {id ? (
                <div style={{ marginLeft: 20 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        style={{ whiteSpace: 'nowrap', marginBottom: 18 }}
                        href="/pricing"
                    >
                        Price List
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        style={{ whiteSpace: 'nowrap' }}
                        href="mailto:sales@vulners.com"
                        target="_blank"
                    >
                        Contact Us
                    </Button>
                </div>
            ) : (
                <Tooltip title="Login">
                    <Button variant="contained" color="primary" onClick={openLoginDialog}>
                        Login
                    </Button>
                </Tooltip>
            )}
        </Box>
    );
};

export default inject('userStore', 'dialogStore')(observer(PrivateArea));
